import React from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { Link } from 'react-router-dom';

const Footer = () => {
  const { t } = useLanguage();
  const currentYear = new Date().getFullYear();

  return (
    <footer 
      data-testid="footer"
      className="relative py-16"
      style={{ backgroundColor: '#050A14', borderTop: '1px solid rgba(255, 255, 255, 0.04)' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {/* Logo & Tagline */}
          <div className="text-center md:text-left">
            <Link 
              to="/" 
              className="flex items-center justify-center md:justify-start gap-2"
            >
              <img 
                src="https://customer-assets.emergentagent.com/job_metalove-preview/artifacts/hs618z4m_Logo%20ML%20dore%CC%81.png"
                alt="MetaLove"
                className="h-5 w-auto"
                style={{ filter: 'brightness(0.4) sepia(0.1)', opacity: 0.5 }}
              />
              <span 
                className="font-heading text-base tracking-[0.2em]"
                style={{ color: '#6B7280' }}
              >
                METALOVE
              </span>
            </Link>
            <p 
              className="text-xs mt-3 tracking-wide"
              style={{ color: '#6B7280' }}
            >
              {t('footer.tagline')}
            </p>
          </div>

          {/* Links & Copyright */}
          <div className="text-center md:text-right">
            <div className="flex items-center justify-center md:justify-end gap-8 mb-4">
              <Link 
                to="/confidentialite"
                data-testid="footer-privacy"
                className="text-xs tracking-[0.1em] transition-colors"
                style={{ color: '#6B7280' }}
              >
                {t('footer.privacy')}
              </Link>
              <Link 
                to="/mentions-legales"
                data-testid="footer-terms"
                className="text-xs tracking-[0.1em] transition-colors"
                style={{ color: '#6B7280' }}
              >
                {t('footer.terms')}
              </Link>
            </div>
            <p 
              className="text-xs"
              style={{ color: '#4B5563' }}
            >
              © {currentYear} MetaLove. {t('footer.rights')}.
            </p>
            <p 
              className="text-xs mt-2"
              style={{ color: '#374151' }}
            >
              {t('footer.trademark')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
